import { firstValueFrom, forkJoin, of, race } from 'rxjs';
import { delay } from 'rxjs/operators';

export function prefetchImages(
  sources: string[],
  resolveTimeout: number = 500,
) {
  const obs$ = forkJoin(
    sources.filter(Boolean).map(
      (src) =>
        new Promise((resolve, reject) => {
          const image = new Image();

          image.onload = () => resolve(src);
          image.onerror = () => reject();

          image.src = src;
        }),
    ),
  );

  return firstValueFrom(race(obs$, of([]).pipe(delay(resolveTimeout))));
}
